module.exports = __webpack_public_path__ + "img/66f2108.png";